import { render } from "./NoteItemPopUp.vue?vue&type=template&id=6bc3c834"
import script from "./NoteItemPopUp.vue?vue&type=script&lang=js"
export * from "./NoteItemPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__